import { Menu, menuItemFactory, renderMenuItems } from '@elliemae/ds-basic/Menu';
import MenuItemClickableHOC from './MenuItemClickableHOC.js';
import MenuItemGroupSelectionHOC from './MenuItemGroupSelectionHOC.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import '@elliemae/ds-utilities/utils';
import './DropdownMenuContext.js';

var itemTypes = {
  separator: Menu.Separator,
  menuitem: MenuItemClickableHOC(Menu.Item),
  radio: MenuItemClickableHOC(Menu.ItemRadio, {
    type: 'selectable'
  }),
  checkbox: MenuItemClickableHOC(Menu.ItemCheckbox, {
    type: 'selectable'
  }),
  submenu: Menu.SubMenu,
  'selection-group': MenuItemGroupSelectionHOC(Menu.SelectionGroup)
};
var factory = function factory(type) {
  return menuItemFactory(type, itemTypes, itemTypes.menuitem);
};
var renderOptions = function renderOptions(options) {
  return renderMenuItems(options, factory);
};

export { factory, renderOptions };
//# sourceMappingURL=decoratedMenuItemFactory.js.map
